import { AllyBase } from "../base";
import { AllyElementBase } from "./ally-element-base.class";

/**
 * --- This class provides part of the function matrix created by the AllyElements object. ---
 * 
 * This class enables keyboard controles for all element that have an event listerner listening for click events.
 * 
 * @extends AllyElementBase
 * @see AllyElements
 */
export class AllyEnter extends AllyElementBase {
    /**
     * @param bridge The bridge to the parent in the hierarchical tree.
     * @see AllyBase
     */
    constructor(bridge: () => AllyBase) {
        super(bridge, (matrix) => {
            matrix[0].push((scope) => {
                if (scope.self.library.angular.hasClickListener(scope.self.node)) {
                    let self = scope.self;
                    let listener2 = self.eventListener.createEventListener(self, "keydown", (event: Event & Partial<KeyboardEvent>) => {
                        if (event.key && event.key === 'Enter') {
                            event.preventDefault();
                        }
                    });
                    let listener = self.eventListener.createEventListener(self, "keyup", (event: Event & Partial<KeyboardEvent> & {__deEnterHandled?: boolean}) => {
                        if (event.key && event.key === 'Enter' && !event.__deEnterHandled) {
                            // Flag the event so the added activation fires only once (for the
                            // innermost clickable element) as it bubbles. This replaces a blanket
                            // stopPropagation(), which would also swallow the application's own
                            // Enter handlers and change familiar keyboard behaviour.
                            event.__deEnterHandled = true;
                            self.library.angular.click(self.node);
                        }
                    });
                    let index = self.attribute.createIndex(0);
                    self.resetFunctions.push(() => {
                        listener2.destroy();
                        listener.destroy();
                        self.attribute.setAttribute("tabindex", index, undefined);
                    });
                    self.attribute.setAttribute("tabindex", index, "0");
                }
            });
        }, 6);
    }
}